import { Grid } from "@material-ui/core";
import { FunctionComponent } from "react";
import styled from "styled-components";
import { capitalCase } from "change-case";
import { Widget } from "../../../components/widget";
import { ChainDTO } from "../../../store/chain/models/dto";
import { Score } from "../../../components/score";
import { useTranslation } from "react-i18next";

const StyledWidget = styled(Widget)`
  &:not(:last-child) {
    margin-bottom: 1em;
  }
`;

const riskProfileScores: Array<
  keyof ChainDTO.Responses.GetSingleWalletReports.T["riskProfile"]
> = [
  "atm",
  "darknetMarketplaces",
  "darknetServices",
  "gamblingServices",
  "illegalServices",
  "onlineMarketplaces",
  "miner",
  "mixer",
  "paymentProcessors",
  "ransom",
  "scam",
  "stolenCoins",
  "onlineWallet",
];

const exchangeRiskProfileScores: Array<
  keyof ChainDTO.Responses.GetSingleWalletReports.T["riskProfile"]["exchangeRiskProfile"]
> = [
  "highRiskExchangesScore",
  "moderateRiskExchangesScore",
  "lowRiskExchangesScore",
  "veryHighRiskExchangesScore",
  "fraudulentExchangesScore",
];

const p2pExchangeRiskProfileScores: Array<
  keyof ChainDTO.Responses.GetSingleWalletReports.T["riskProfile"]["p2pExchangeRiskProfile"]
> = ["highRiskP2PExchangesScore", "lowRiskP2PExchangesScore"];

export const OnChainAnalysisSingle: FunctionComponent<{
  item: ChainDTO.Responses.GetSingleWalletReports.T;
}> = ({ item }) => {
  const { riskScore, riskProfile } = item;
  const { t } = useTranslation("blockchain-tools");
  return (
    <>
      <StyledWidget title={t("overall-risk-score")}>
        <Grid container spacing={3}>
          {riskScore !== null ? (
            <Grid item xs={12}>
              <Score value={riskScore * 100} title="Overall" size="large" />
            </Grid>
          ) : null}
          {riskProfileScores.map((item) => (
            <Grid item xs={6}>
              <Score
                value={(riskProfile[item] as number) * 100}
                title={capitalCase(item)}
              />
            </Grid>
          ))}
        </Grid>
      </StyledWidget>
      <StyledWidget title={t("exchange-risk-analysis")}>
        <Grid container spacing={3}>
          {exchangeRiskProfileScores.map((item) => (
            <Grid item xs={6}>
              <Score
                value={(riskProfile.exchangeRiskProfile[item] as number) * 100}
                title={capitalCase(item)}
              />
            </Grid>
          ))}
        </Grid>
      </StyledWidget>
      <StyledWidget title={t("p2p-exchange-risk-analysis")}>
        <Grid container spacing={3}>
          {p2pExchangeRiskProfileScores.map((item) => (
            <Grid item xs={6}>
              <Score
                value={
                  (riskProfile.p2pExchangeRiskProfile[item] as number) * 100
                }
                title={capitalCase(item)}
              />
            </Grid>
          ))}
        </Grid>
      </StyledWidget>
    </>
  );
};
